exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination-container {\n  justify-content: center;\n  display: flex;\n}\n\n.page-active {\n  background: #A3826C !important;\n  transition: 0.2s ease-in-out;\n}\n\n.pagination-container>ul>li {\n  padding: 15px;\n  display: inline-block;\n  text-align: center;\n  height: 50px;\n  width: 50px;\n  border-radius: 5px;\n  margin: 0px 5px;\n  background: #42474b;\n  color: white;\n  list-style-type: none;\n  text-align: center;\n}\n\n.pagination-container>ul>li:hover {\n  cursor: pointer;\n}", ""]);

// exports
